import React from 'react';
import styled from '@emotion/styled';

const Grid = styled.div`
  display: ${props => (props.hiddenForSmallScreens ? 'none' : 'flex')};
  @media (min-width: ${props => props.theme.tablet}) {
    display: flex;
  }
  flex-wrap: ${props => (props.noWrap ? 'nowrap' : 'wrap')};
  @media (min-width: ${props => props.theme.tablet}) {
    ${props => (props.noWrapForMd ? 'flex-wrap: nowrap;' : null)};
  }
  justify-content: ${props => {
    if (props.justify === 'center') {
      return 'center';
    }
    if (props.justify === 'end') {
      return 'flex-end';
    }
    if (props.justify) {
      return 'space-' + props.justify;
    }
    return 'flex-start';
  }};
  align-items: ${props => {
    if (props.verticalAlign === 'end') {
      return 'flex-end';
    }
    return props.verticalAlign;
  }};
  width: ${props => (props.noGutters ? '100%' : 'calc(100% + 1.5rem)')};
  margin-left: ${props => (props.noGutters ? '0' : '-.75rem')};
  margin-right: ${props => (props.noGutters ? '0' : '-.75rem')};
  margin-bottom: ${props => (props.marginBottom ? '1rem' : '0')}
    ${props =>
      props.debug ? '& > div { background: rgba(255,0,0,.25); }' : null}
    ${props =>
      props.debug
        ? '& > div:nth-child(even) { background: rgba(0,255,0,.25); }'
        : null};
  ${props => (props.height ? 'height: ' + props.height + ';' : null)}
  @media print {
    display: block;
    overflow: visible;
  }
`;

export default Grid;
